import { CameraNotificationStatus } from '@EcamModel/model/CameraNotification';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../hooks/NotificationProvider';
import LayoutNotificationItem, { NotificationItemProps } from './LayoutNotificationItem';
import color from '@theme/Colors';

export default function PcnLackVrnNotificationItem(props: NotificationItemProps) {
    const navigate = useNavigate();
    const { markRead, handleClose } = useNotification();
    const { item, index } = props;

    const isUnread = item?.Status === CameraNotificationStatus.Unread;

    const handleMarkRead = () => {
        isUnread && markRead([item?.Id!]);
        handleClose();
        navigate(`/verification/contravention/${item?.GroupPotentialContraventionId}?isFilterPcLackVrn=true`);
    };

    return (
        <LayoutNotificationItem
            handleMarkRead={handleMarkRead}
            index={index}
            item={item}
            children={
                <Typography>
                    {`PCNs associated with VRN `}{' '}
                    <Typography
                        variant="caption"
                        color={color.secondary}
                    >{`${item?.GroupPotentialContravention?.Plate}`}</Typography>{' '}
                    {`in this zone are missing vehicle information.`}
                </Typography>
            }
            title={`Zone: ${item?.GroupPotentialContravention?.Zone?.PublicName ?? ''}`}
        />
    );
}
